import React, { useEffect, useState } from 'react';

import { Col, Container, Row } from 'reactstrap';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import './index.css';

import { DashBoardTitle } from '../../../Components/Title';
import { useNavigate } from 'react-router-dom';
import { Permissions } from '../../../constants/Permissions';
import { useSelector } from 'react-redux';
import CalenderView from '../../../Components/CalenderView/CalenderView';
import LoginUserList from '../../../Components/LoginUserList/LoginUserList';
import SingleCalenderView from '../../../Components/SingleCalenderView/SingleCalenderView';
import UserLoginHistory from '../../../Components/UserLoginHistory/UserLoginHistory';
import { CommonButton } from '../../../Components/CommonComponents';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const LoginDetails = () => {
  const navigate = useNavigate();
  const { permissionArr } = useSelector((state) => state.UserGetReducer);
  const localPermission = permissionArr;
  useEffect(() => {
    if (!localPermission.includes(Permissions.LOGIN_REPORT)) {
      navigate('/');
    }
  }, [...localPermission]);

  const [currentDate, setCurrentDate] = useState(Date.now());

  useEffect(() => {
    setCurrentDate(Date.now());
  }, []);

  const [isLoading, setIsloading] = useState(false);
  const [view, setView] = useState('all');
  const [selectedTab, setSelectedTab] = useState(0);

  const [selectedUserName, setSelectedUserName] = useState(null);

  const viewUser = (user) => {
    setSelectedUserName(user);
    setView('user');
  };

  console.log('view', view)

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
    <div id="manageDealer">
      {isLoading && <CustomSpinner />}
      <div className="pageWrapper">
        <Container fluid>
          <Row>
            <Col xs={12}>
              <div className="pageheader">
                <DashBoardTitle
                  dashBorardName="LOGIN REPORT"
                  className="lightTitle"
                />
                {view === 'user' && (
                  <CommonButton
                    name={'Back'}
                    btnClass={'btnTernary mt-0 mb-0 mr-0'}
                    type="button"
                    onClick={() => {
                      setView('all');
                      setSelectedUserName(null);
                    }}
                  />
                )}
              </div>
            </Col>
          </Row>
          {view === 'all' ? (
            <Row>
              <Col xs={12} md={7}>
                <CalenderView
                  setDate={setCurrentDate}
                  currDate={currentDate}
                  setLoading={setIsloading}
                  setSelectedTab={setSelectedTab}
                />
              </Col>
              <Col xs={12} md={5} style={{ marginTop: '5rem' }}>
                <LoginUserList
                  viewUser={viewUser}
                  currentDate={currentDate}
                  selectedTab={selectedTab}
                  setSelectedTab={setSelectedTab}
                  setLoading={setIsloading}
                />
              </Col>
            </Row>
          ) : (
            <Row>
              <Col xs={12} md={7}>
                <SingleCalenderView
                  user={selectedUserName}
                  setDate={setCurrentDate}
                  currDate={currentDate}
                  setLoading={setIsloading}
                />
              </Col>
              <Col xs={12} md={5} style={{ marginTop: '5rem' }}>
                <UserLoginHistory
                  user={selectedUserName}
                  currentDate={currentDate}
                  setLoading={setIsloading}
                />
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </div>
    </div>
    </div>
</div>
</>
  );
};

export default LoginDetails;
